module.exports = __webpack_public_path__ + "img/resent-fax-new.e881f52a.svg";